import { module as BaseModule } from 'modujs'

const addScript = ({ src, id, onLoad }) => {
  const existing = document.getElementById(id)
  if (existing) {
    return existing
  }
  const script = document.createElement('script')
  script.src = src
  script.id = id
  script.async = true
  script.onload = () => {
    if (onLoad) {
      onLoad()
    }
  }
  document.body.appendChild(script)
  return script
}

export default class extends BaseModule {
  init() {
    this.close = this.el.querySelector('.cookieClose')

    this.consent = {
      analytics: true,
    }

    this.getStoredTrackingOptions()
    this.executeScripts()
    this.setStoredTrackingOptions()
    this.executeScripts()

    const cookieClosed = JSON.parse(localStorage.getItem('cookieClosed'))

    if (cookieClosed) return
    this.showBanner()
    this.initEventListeners()
  }

  getStoredTrackingOptions() {
    const storedTrackingOptions = JSON.parse(
      localStorage.getItem('trackingOptions')
    )
    if (storedTrackingOptions) {
      this.storedTrackingOptions = true
      Object.keys(storedTrackingOptions).forEach((key) => {
        this.consent[key] = storedTrackingOptions[key]
      })
    }
  }

  setStoredTrackingOptions() {
    localStorage.setItem('trackingOptions', JSON.stringify(this.consent))
  }

  initEventListeners() {
    this.close.addEventListener('click', () => {
      this.hideBanner()
      localStorage.setItem('cookieClosed', true)
    })

    window.addEventListener('resize', () => this.resize())
  }

  showBanner() {
    this.el.classList.add('--active')
    this.setCookieSpace(this.el.offsetHeight)
  }

  hideBanner() {
    this.el.classList.remove('--active')
    this.setCookieSpace(0)
  }

  setCookieSpace(value) {
    value > 0 ? (this.height = value + 16) : (this.height = 0) // 16px is the space between cookie banner and header menu
    document.documentElement.style.setProperty(
      '--cookie-height',
      `${this.height}px`
    )
  }

  executeScripts() {
    if (!this.production) return
    // console.log('executing scripts')
    if (this.consent.analytics === true) this.initAnalytics()
    if (this.consent.analytics === false)
      window['ga-disable-G-9K4DGZBDSD'] = true
  }

  initAnalytics() {
    addScript({
      src: 'https://www.googletagmanager.com/gtag/js?id=G-9K4DGZBDSD',
      id: 'gtag',
      onLoad: () => {
        // console.log('gtag loaded')

        window.dataLayer = window.dataLayer || []
        function gtag() {
          dataLayer.push(arguments) /*eslint-disable-line*/
        }
        gtag('js', new Date())
        gtag('config', 'G-9K4DGZBDSD')
      },
    })
    return this
  }

  resize() {
    this.el.classList.contains('--active') &&
      this.setCookieSpace(this.el.offsetHeight)
  }
}
